import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export default function DoctorPortalRedirect() {
  const {pathname}=useLocation();
  const page=pathname.endsWith('/appointments')?'appointments':pathname.endsWith('/settings')?'profile':'sign-in';
  const url=`https://nephrocorenexus.com/doctor/${page}`;
  useEffect(()=>{window.location.replace(url);},[url]);
  return <main className="login-page"><p>Doctor accounts now use the NephroCore website. <a href={url}>Open the doctor portal</a></p></main>;
}
